import { Base, Expand, Flex, Icon, Link, Text } from '@bitrise/bitkit';
import { CrashEventThread, SupportedPlatforms } from '@trace/types';
import React, { useState, FunctionComponent } from 'react';
import CrashStackTrace from './CrashStackTrace';

interface Props extends CrashEventThread {
  index: number;
  platform: SupportedPlatforms;
  title?: string;
}

const CrashThread: FunctionComponent<Props> = ({ index, platform, stacktrace, title }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Base margin="x2">
      <Flex
        alignChildrenVertical="middle"
        clickable
        direction="horizontal"
        gap="x4"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Flex grow initial="none">
          <Text margin="x1" monospace size="x2">
            {title || `Thread ${String(index + 1).padStart(2, '0')}`}
          </Text>
        </Flex>

        <Flex>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link color="grape-3">
            <Text config="8">
              <Flex alignChildrenVertical="middle" direction="horizontal" gap="x1">
                <Flex>{isExpanded ? 'Hide' : 'Show'}</Flex>

                <Flex>
                  <Icon name={isExpanded ? 'MinusClose' : 'PlusOpen'} />
                </Flex>
              </Flex>
            </Text>
          </Link>
        </Flex>
      </Flex>

      <Expand expanded={isExpanded} paddingVertical="x3">
        <CrashStackTrace borderRadius="x2" platform={platform} stacktrace={stacktrace} />
      </Expand>
    </Base>
  );
};

export default CrashThread;
